import script from "./SanitaryCert.vue?vue&type=script&setup=true&lang=js"
export * from "./SanitaryCert.vue?vue&type=script&setup=true&lang=js"

import "./SanitaryCert.vue?vue&type=style&index=0&id=02b45d00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b45d00"]])

export default __exports__